import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';
import LoadingDots from 'Components/LoadingDots';

const Modal = ({
  cancel,
  confirm,
  heading,
  message,
  message2,
  onClose,
  onConfirm,
}) => {
  const [mounted, setMounted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    onConfirm();
  };

  useEffect(() => {
    setTimeout(() => {
      setMounted(true);
    }, 100);
  });

  return (
    <div className={`modal ${mounted && 'mounted'}`} role="dialog">
      <div className="modal-outer" onClick={onClose} />
      <div className="modal-inner">
        <div className="close" alt="Close" onClick={onClose}>
          <IconSvg className="close-svg" type="close" />
        </div>
        <h1>{heading}</h1>
        <p>{message}</p>
        {message2 && <p>{message2}</p>}
        <button
          className="btn--short"
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? <LoadingDots /> : confirm}
        </button>
        <button
          className="btn--short btn--secondary"
          onClick={onClose}
          disabled={submitting}
        >
          {cancel}
        </button>
      </div>
    </div>
  );
};

Modal.propTypes = {
  cancel: PropTypes.string.isRequired,
  confirm: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  message2: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

Modal.defaultProps = {
  message2: '',
};

export default Modal;
